import httpRequest from "@/request/index";
const baseURL = import.meta.env.VITE_APP_LOGIN_API;
import { getToken } from "@/utils/login";
// 定义返回的数据类型
interface ResponseData<T> {
  code: number;
  message: string;
  msg: string;
  data: T;
}
export const ApiUser = {
  // 发送验证码
  sendCodeApi: (json: any) => {
    const data = json;
    return httpRequest.request({
      url: "api/basic/sms/h5/getVerifyCodeByMobileTx",
      data,
      method: "post",
      baseURL,
      headers: {
        version: "v1.0.1",
        Action: "10004",
      },
    }) as Promise<ResponseData<any>>;
  },
  // 注册
  registerAccountApi: (json: any) => {
    const data = json;
    return httpRequest.request({
      url: "api/h5/uc/wapRegister",
      data,
      method: "post",
      baseURL,
      headers: {
        version: "v1.0.1",
        Action: "10004",
      },
    }) as Promise<ResponseData<any>>;
  },
  // 登录
  loginPhoneApi: (json: any) => {
    const data = json;
    return httpRequest.request({
      url: "api/h5/uc/wapLogin",
      data,
      method: "post",
      baseURL,
      headers: {
        version: "v1.0.1",
        Action: "10004",
      },
    }) as Promise<ResponseData<any>>;
  },
  // 获取用户信息
  getUserInfoApi: (json: any) => {
    const data = json;
    return httpRequest.request({
      url: "api/h5/uc/userInfo",
      data,
      method: "post",
      baseURL,
      headers: {
        version: "v1.0.1",
        Action: "10004",
        sessionId: getToken(),
      },
    }) as Promise<ResponseData<any>>;
  },
  // 判断用户分组
  authenticationUser: (json: any) => {
    const data = json;
    return httpRequest.request({
      url: "api/h5/uc/security/userGroup/member/exists",
      data,
      method: "post",
      baseURL,
      headers: {
        version: "v1.0.1",
        Action: "10004",
        sessionId: getToken(),
      },
    });
  },
  // 获取二维码
  getQrCode: () => {
    return httpRequest.request({
      url: "api/uc/pc/getQrcode",
      method: "get",
      baseURL,
      headers: {
        version: "v1.0.1",
        Action: "10004",
      },
    });
  },
  // 二维码登录
  checkQrcode: (json: any) => {
    const data = json;
    return httpRequest.request({
      url: "api/h5/uc/auth/CodeLoginInfo",
      data,
      method: "post",
      baseURL,
      headers: {
        version: "v1.0.1",
        Action: "10004",
      },
    });
  },
  // token登录
  postOATokenLogin: (data) => {
    return httpRequest.request({
      url: "api/zba/user/oaTokenLogin",
      data,
      method: "post",
    });
  },
};
